import React, { useEffect, useState } from "react";
import {
  Grid,
  useMediaQuery,
  Box,
  Typography,
  IconButton,
  Select,
  MenuItem,
  TextField,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { DataGrid } from "@mui/x-data-grid";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import SaveIcon from "@mui/icons-material/Save";
import {
  WHPicking_Detail_GetRow_GETROW,
  WHPicking_Complete_GETROW,
  BarcodeScanningUpdate_GETROW,
  DropIdEnquiry_GETROW,
  itemEnquiry_GETROW,
} from "../../Server/ApiV2";
import { vRdxUserInfo } from "../../Redux/roStore";
import {
  CmpButton,
  CmpSelectBox,
  CmpSelectField,
  CmpTextField,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Breadcrumbs from "./component/BreadCrumbs";
import { useNavigate } from "react-router-dom";
import ViewListModal from "./component/ViewListModal";
import { Barcode_Init, Head_Set } from "./SliceBarcodeScanning";

export default function BarcodeScanning() {
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const sHead = useSelector((state) => state.SliceBarcodeScanning.value.Head);
  const [rows, setRows] = useState([]);
  const [sViewListModal, setViewListModal] = useState(false);
  
   
  const [TypeArr, setTypeArr] = useState([
    {
      UId: "SHELF TAG",
      Name: "SHELF TAG",
    },
    {
      UId: "STICKER",
      Name: "STICKER",
    },
    {
      UId: "TAG",
      Name: "TAG",
    },
  ]);
  const [filter, setFilter] = useState("");

   
  

  const handleQtyChange = (value, index) => {
    const updatedRows = rows.map((row, i) =>
      i === index ? { ...row, PackQty: value } : row
    );
    setRows(updatedRows);
  };

  const Save = async (row) => {
    console.log(rows); 
    const vRdxUserInfoObj = vRdxUserInfo();
    const payload = {
      v_UId: sHead.SheetNo,
      v_Barcode: row.Barcode,
      v_Typ: sHead.Type,
      v_ItmCd: row.ItmCd,
      v_Unit: row.Unit,
      v_Qty: row.PackQty,
      v_UserCd:vRdxUserInfoObj.UserID,  
      v_IP:vRdxUserInfoObj.IP,
    };
    let resp = await BarcodeScanningUpdate_GETROW(
      fcheck_null_undefine_replace_empty(payload)
    );
    if (resp?.status === 200) {
      console.log(resp);
      fAlertToast("SUCCESS", "Successfully Save");
      // handleLoad();
      setRows([])
    }  
  };
  const ViewList = async () => {
    setViewListModal(true);
    
  };

  const handleLoad = async (xFilter = filter) => {
    if (sHead.SheetNo == "" || sHead.Type == "") {
      fAlertToast(
        "FAILED",
        sHead.SheetNo == ""
          ? "Sheet No should not be empty"
          : "Type should not be empty"
      );
    } else {
      let payload = {
        v_Barcode: xFilter,
        v_Loc: "",
      };
      let resp = await itemEnquiry_GETROW(
        fcheck_null_undefine_replace_empty(payload)
      );
      if (resp?.status === 200) {
        console.log(resp);
        let respData = resp?.data?.ResultSet;

        setRows(respData);
        setFilter("")
      } else {
        setRows([]);
      }
      setTimeout(async () => {
        document.getElementsByName("SCAN")[0]?.focus();
      }, 100);
     
    }
  };

  return (
    <div className="">
      <div className="mt-2">
        <Breadcrumbs />{" "}
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-11 m-auto">
          <CmpTypographyField
            xcomponent={"span"}
            xText={"Head"}
            xfontSize="1rem !important"
            xtextDecoration="underline"
          />
          
          <Grid container   rowSpacing={1} columnSpacing={1}  columnGap={1.5} alignItems="center" >
            <Grid item xs={3} sm={1} md={1}>
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "primary.main",
                    fontWeight: "bold",
                    fontSize: {
                      md: "15px !important",
                      sm: "14px !important",
                      xs: "12px",
                    },
                  }}
                >
                  Sheet.No
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8} sm={3} md={3}>
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "primary.main",
                    fontWeight: "bold",
                    fontSize: {
                      md: "15px !important",
                      sm: "14px !important",
                      xs: "12px",
                    },
                  }}
                >
                  <TextField
                  name="SheetNo"
                    type="text"
                    value={sHead.SheetNo}
                    onChange={(e) => {
                      dispatch(Head_Set({
                        ...sHead,
                        SheetNo: e.target.value,
                      })) 
                      
                    }}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputProps={{ sx: { fontWeight: "bold" } }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter"){
                        setTimeout(async () => {
                          document.getElementsByName("SCAN")[0]?.focus();
                        }, 100);
                      }
                    }}
                  />
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={3} sm={0.5} md={1}>
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "primary.main",
                    fontWeight: "bold",
                    fontSize: {
                      md: "15px !important",
                      sm: "14px !important",
                      xs: "12px",
                    },
                  }}
                >
                  Type
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8} sm={2.5} md={3}>
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "primary.main",
                    fontWeight: "bold",
                    fontSize: {
                      md: "15px !important",
                      sm: "14px !important",
                      xs: "12px",
                    },
                  }}
                >
                  <CmpSelectBox
                    xLabelText=""
                    xValue={sHead.Type}
                    xOnChange={(e) =>
                      // setHead(e.target.value, index)
                      dispatch(Head_Set({
                        ...sHead,
                        Type: e.target.value,
                      })) 
                      
                    }
                    xName={"Type"}
                    xData={TypeArr}
                    xValueMember={"Name1"}
                    xDispalyMember={"Name1"}
                    xDisable={false}
                    xsize="small"
                    sx={{ fontWeight: "bold" }}
                  />
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={5.5} sm={2} md={1} textAlign={'center'}>
            <CmpButton
            xWidth="100%"
              xbtnName="New"
              xOnClick={() => {
                if(filter == "") {
                   
                  dispatch(Barcode_Init())
                  setFilter("")
                  setRows([])
                  setTimeout(async () => {
                    document.getElementsByName("SheetNo")[0]?.focus();
                  }, 100);
                }else{
                  setFilter("")
                }
               
              }}
              xVariant="contained"
              xSize="small"
              // xDisabled={(vRdxHead?.Status)?.toUpperCase() == "POSTED"}
            />
            </Grid>
            <Grid item xs={5.5} sm={1.5} md={1}  textAlign={'center'}>
            <CmpButton
              xWidth="100%"
              xbtnName="View List"
              xOnClick={() => {ViewList()}}
              xVariant="contained"
              xSize="small"
              // xDisabled={(vRdxHead?.Status)?.toUpperCase() == "POSTED"}
            />
            </Grid>
          </Grid>
          <CmpTypographyField
            xcomponent={"span"}
            xText={"Detail"}
            xfontSize="1rem !important"
            xtextDecoration="underline"
          />
          <Grid
            container
            spacing={0.2}
            columnGap={0.2}
            style={{   alignItems: "center" }}
          >
            <Grid item xs={8} md={4}>
              <TextField
                fullWidth
                label="SCAN"
                name="SCAN"
                variant="outlined"
                value={filter}
                onChange={(e) => {
                  setFilter(e.target.value);
                  // handleFilter((e.target.value).toUpperCase());
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter" || e._reactName === "onClick") {
                    handleLoad(filter.toUpperCase());
                  }
                }}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 0.5,
                    borderColor: "#1976d2",
                  },
                }}
              />
            </Grid>
            <Grid item xs={"auto"}>
            <CmpButton
              xWidth="100%"
              xbtnName="Load"
              xOnClick={() => handleLoad(filter.toUpperCase())}
              xVariant="contained"
              xSize="small"
              // xDisabled={(vRdxHead?.Status)?.toUpperCase() == "POSTED"}
            />
              {/* <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => handleLoad(filter.toUpperCase())}
                size="small"
              >
                Load
              </Button> */}
            </Grid>
          </Grid>
          <Grid
            container
            spacing={1}
            marginY={"5px"}
            // height={"78vh"}
            // sx={{ overflowY: "scroll", height: { md: "78vh", xs: "58vh" } }}
          >
            {rows.map((row, index) => (
              <Grid item xs={12} sm={12} md={6} key={row.id}>
                <Box
                  sx={{
                    border: 1,
                    borderColor: "primary.main",
                    borderRadius: "6px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    // height: "100%",
                    padding: "10px",
                  }}
                >
                  <>
                    <Grid container spacing={0.1} alignItems={"center"}>
                      <Grid item xs={4} md={3}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            color: "primary.main",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          Item.Name:
                        </Typography>
                      </Grid>
                      <Grid item xs={8} md={9}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "bold",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          {row.Name2}
                        </Typography>
                      </Grid>

                      <Grid item xs={4} md={3}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            color: "primary.main",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          Item Code
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={8}
                        md={9}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "bold",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          {row.ItmCd}
                        </Typography>
                        <IconButton
                          color="primary"
                          onClick={() => Save(row)}
                          disabled={row.C_PickStatus}
                        >
                          {/* <SaveIcon /> */}
                          <CheckCircleIcon />
                        </IconButton>
                      </Grid>
                      <Grid item xs={4} md={3}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            color: "primary.main",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          Unit
                        </Typography>
                      </Grid>
                      <Grid item xs={2} md={1}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "bold",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          {row.Unit}
                        </Typography>
                      </Grid>
                      <Grid item xs={2} md={3}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            color: "primary.main",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          Qty:
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={4}
                        md={3}
                        sx={{
                          fontWeight: "bold",
                          color: "primary.main",
                          fontSize: {
                            md: "15px !important",
                            sm: "14px !important",
                            xs: "12px",
                          },
                        }}
                      >
                        <TextField
                          type="number"
                          value={row.PackQty}
                          onChange={(e) =>
                            handleQtyChange(e.target.value, index)
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                          InputProps={{ sx: { fontWeight: "bold" } }}
                        />
                      </Grid>
                    </Grid>
                  </>
                </Box>
              </Grid>
            ))}
          </Grid>
          {/* <Grid container justifyContent="flex-end">
            <CmpButton
              xbtnName="Complete"
              xOnClick={() => Complete()}
              xVariant="contained"
              xSize="small"
              // xDisabled={(vRdxHead?.Status)?.toUpperCase() == "POSTED"}
            />
          </Grid> */}
        </div>
      </div>
      <ViewListModal
        open={sViewListModal}
        xTitle={`Print Barcode Item (${sHead.Type})`}
        
        fCloseSearchModal={() => {
          setViewListModal(false);
        }} 
      />
    </div>
  );
}
